import React, {useEffect, useState} from 'react';
import { Box } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import ChanceStepperContainer from '../../containers/chancemng/setpper/ChanceStepperContainer';



const ChanceStepPage = () => {
  const { id, step, tab } = useParams();
  const [activeStep, setActiveStep] = useState(0);
  const [activeTap, setActiveTap] = useState(0);
  let navigate = useNavigate();

  useEffect(() => {
    // 주소의 단계·탭 번호는 1부터다. 화면에서는 0부터 쓰므로 1을 뺀다.
    //
    // 예전에는 if(step)/if(tab) 로만 걸렀는데, 문자열 "0" 은 참이라 그대로 통과해
    // -1 이 되고 어느 탭도 안 걸려 화면이 통째로 비었다.
    // 범위를 벗어나면 첫 번째로 떨어뜨린다 — 링크가 잘못돼도 화면은 나와야 한다.
    const toIndex = (value) => {
      const n = Number(value);
      return Number.isInteger(n) && n >= 1 ? n - 1 : 0;
    };

    setActiveStep(toIndex(step));
    setActiveTap(toIndex(tab));
  }, [id, step, tab]);

  const handleTabChange = (event, newValue)=>{
    // console.log('handleTabChange', newValue);
    // setActiveTap(newValue);
    let newStep = newValue+1;
    navigate(`/chancemng/${id}/${step}/${newStep}`);
  }

  return (
    
    <Box
      sx={{
        mt: { xs: 0.5, sm: 2 },
        mx: { xs: 0, sm: 2 },
      }}
    >
     
      <ChanceStepperContainer activeStep={activeStep} activeTap={activeTap} handleTabChange={handleTabChange}/>
     
    </Box>
  );
};

export default ChanceStepPage;
